import React from 'react'
import { Button, Dialog, DialogContent, Fab } from '@mui/material'

import s from './styles.module.scss'

const fabSx = {
  position: 'fixed',
  bottom: 90,
  right: 15,
  zIndex: 2000,
  width: 75,
  height: 70,
  fontSize: 12,
  lineHeight: 1.2,
}

const dialogContentSx = {
  overflow: 'hidden',
  p: 0,
  height: '100%',
}

const FloatingActionWithDialog = ({ title, children, open, setOpen }) => {
  const handleOpen = () => setOpen(true)
  const handleClose = () => {
    localStorage.setItem('tallyFormDismissed-ZK', 'true')
    setOpen(false)
  }
  return (
    <>
      <Fab color="secondary" onClick={handleOpen} sx={fabSx}>
        {title}
      </Fab>

      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="sm"
        classes={{ paper: s.paperProps }}
        PaperProps={{
          sx: {
            height: '85vh',
            maxHeight: '85vh',
          },
        }}
      >
        <DialogContent sx={dialogContentSx}>
          <Button onClick={handleClose} className={s.closeBtn}>
            X
          </Button>

          {children}
        </DialogContent>
      </Dialog>
    </>
  )
}

export default FloatingActionWithDialog
